<template>
  <div class="scroll_flex_container">

    <div class="unlogin-cover h-full w-full" v-if="!isLogin">
      <levitateLoginCard />
    </div>
    <div class="row_end_center member_card_container">
      <memberCard></memberCard>
    </div>

    <div class="column_center_start card_container">
      <div class="row_end_center carrier_container" :style="{ height: isLogin ? '280px' : '320px' }">
        <carrierCard style="margin-top: 45px;"></carrierCard>
      </div>
      <!-- <invitation v-if="isLogin" /> -->
      <div class="link_button_container" :class="{ not_login: !isLogin }">
        <linkButton v-for="(item, index) in buttonsArray" :key="index" :buttonItem="item" :index="index"></linkButton>
      </div>
    </div>

    <!-- 新增：店家公告跳窗組件 -->
    <StoreNoticePopup />
  </div>
</template>

<script>
import carrierCard from "../components/home/carrierCard.vue";
import linkButton from "../components/home/linkButton.vue";
import memberCard from "../components/home/memberCard.vue";
import commonUtils from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
// import invitation from '@/components/home/invitation.vue'
import levitateLoginCard from "@/components/home/levitateLoginCard.vue";
import StoreNoticePopup from "@/components/general/storeNoticePopup.vue";
import {
  mapState,
  mapGetters,
} from 'vuex';
export default {
  components: {
    CarrierCard: carrierCard,
    linkButton: linkButton,
    MemberCard: memberCard,
    // invitation: invitation,
    levitateLoginCard: levitateLoginCard,
    StoreNoticePopup,
  },
  computed: {
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      vipLevel: 'vipLevel',
      totalPoints: 'totalPoints',
      accessToken: 'accessToken',
      storeCode: 'storeCode',
      isStoreMember: 'isStoreMember',
    }),
    ...mapState('userData', {
      token: 'token',
      memberInfo: 'memberInfo',
    }),
    ...mapGetters('basic', {
      errorLoginState: 'errorLoginState',
      errorLoginMessage: 'errorLoginMessage',
      storeName: 'storeName',
    }),
    ...mapGetters('line', {
      lineAccessToken: 'accessToken'
    })
  },
  data() {
    return {
      buttonsArray: [
        {
          name: "會員",
          icon: 'face',
          routerName: "changeMemberInfo",
          lock: null,
          buttonSize: "large"
        },
        {
          name: "營業資訊",
          icon: "store",
          routerName: "storeInfo",
          lock: "",
          buttonSize: "large"
        },
        {
          name: "歷史訂單",
          icon: "storefront",
          routerName: "inStoreOrderHistory",
          lock: "",
          buttonSize: "large"
        },
        {
          name: "黑貓商城",
          icon: 'shopping_cart',
          routerName: "marketplace",
          lock: "primary",
          buttonSize: "large"
        },
        {
          name: "LINE下單",
          icon: 'restaurant',
          routerName: "onlineOrder",
          lock: "",
          buttonSize: "large"
        },
        {
          name: "LINE訂單",
          icon: 'list_alt',
          routerName: "onlineOrderHistory",
          lock: "",
          buttonSize: "large"
        },
        {
         name: "集點商城",
         icon: "scatter_plot",
         routerName: "point",
         lock: "",
         buttonSize: "large"
       },
        {
          name: "紅利積分",
          icon: "savings",
          routerName: "bouns",
          lock: "",
          buttonSize: "large"
        },
        {
          name: "優惠卷",
          icon: "local_activity",
          routerName: "coupon",
          lock: "priority",
          buttonSize: "large"
        },
        {
          name: "保管紀錄",
          icon: 'credit_card',
          routerName: "deposit",
          lock: "priority",
          buttonSize: "large"
        },
        {
          name: "問卷",
          icon: "assignment",
          routerName: "form",
          lock: "priority",
          buttonSize: "large"
        },
        {
          name: "行銷活動",
          icon: "star",
          routerName: "promotion",
          lock: "priority",
          buttonSize: "large"
        },
        //2026-03-20 決議移除
        //  {
        //   name: "預約紀錄",
        //   icon: 'event_seat',
        //   routerName: "",
        //   lock: "secondary",
        //   buttonSize: "large"
        // },
        // {
        //   name: "履約票卷",
        //   icon: "loyalty",
        //   routerName: "ticket",
        //   lock: "priority",
        //   buttonSize: "large"
        // },
        // {
        //   name: "儲值信託",
        //   icon: "payments",
        //   routerName: "trust",
        //   lock: "priority",
        //   buttonSize: "large"
        // },
      ],
    };
  },
  watch: {
    async errorLoginState(state) {
      if (state) {
        //關閉 loading 彈窗
        commonUtils.closeLoading();
        const rawError = this.errorLoginMessage
        const rawMessage = rawError?.response?.data?.err_msg || rawError?.response?.data?.message || rawError?.message || rawError
        const status = rawError?.response?.status
        const errorText = String(rawMessage || '')
        const isAuthError =
          status === 401 ||
          status === 403 ||
          errorText === 'IdToken expired.' ||
          errorText === 'token expired' ||
          /unauthorized|request failed with status code 401|token expired|idtoken expired/i.test(errorText)
        const isNetworkError =
          errorText === 'Network Error' ||
          rawError?.code === 'ERR_NETWORK' ||
          (!rawError?.response && rawError?.request)

        this.$store.dispatch("basic/setErrorLogin", { state: false, message: '' });

        if (isAuthError) {
          if (errorText === 'IdToken expired.' || /idtoken expired/i.test(errorText)) {
            this.$store.commit('line/setLineLoginData', {})
          }
          auth.logout()
          return
        }

        let errorMessage = '目前無法完成操作，請稍後再試'
        if (rawMessage == 'No Such Store') {
          errorMessage = '查無此店家'
        } else if (isNetworkError) {
          errorMessage = '網路異常，請稍後再試'
        }

        commonUtils.createToast(
          "error",
          errorMessage
        );

        auth.logout()
      }
    }
  },
  async created() {
    this.$store.dispatch("basic/setErrorLogin", { state: false, message: '' });
    await this.init()

  },
  methods: {
    async init() {
      let loginProcess = false
      /*
        如果有 line access token 則進行 okShopLogin
        登入後判斷是否為該商店會員 若不是商店會員則直接幫用戶加入會員
      */
      if (!this.isLogin && this.lineAccessToken) {
        loginProcess = true
        // 顯示讀loading 彈窗
        /*
        //Modify By Bryant 2025061701//
        commonUtils.createLoading("資料讀取中", "請稍後");
        */
        try {
          await auth.okShopLogin()
        } catch (e) {
          console.error("Failed to login gen2 pos system:", e);
          this.$store.dispatch("basic/setErrorLogin", { state: true, message: e });
          //Modify By Bryant 2025061701//
          commonUtils.closeLoading()
          return
        }
      } else if (!this.accessToken) {
        // 如果沒有 okshop access token || line access token 則不進行任何動作
        //Modify By Bryant 2025061701//
          commonUtils.closeLoading()
        return
      }

      try {
        // 如果不是該商店會員 則進行加入會員
        if (!this.isStoreMember) {
          await this.$store.dispatch('userData/joinMember')
        }
        // 只需等待會員資料讀取完成後，剩餘資料可在背景讀取
        await this.$store.dispatch('userData/fetchMemberInfo')
        await this.$store.dispatch('basic/fetchStoreInfo')
        await this.$store.dispatch('basic/fetchStoreServicesList')
        // 載入店家圖片（背景執行，不阻塞其他流程）
        // 注意：action 內部會檢查登入狀態，未登入時會使用快取
        this.$store.dispatch('basic/fetchStoreImages')
        this.$store.dispatch('spreadsheet/getSpreadSheetData')
        this.$store.dispatch('userData/fetchPointHistory')
        this.$store.dispatch('payment/getPaymentMethods')
      } catch (e) {
        console.error(e)
        commonUtils.closeLoading()
        commonUtils.createToast("error", `會員資料讀取失敗`)
      }

      if (loginProcess) {
        commonUtils.closeLoading();
        commonUtils.createToast("success", "登入成功", "")
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.member_card_container {
  width: 100vw;
  height: 205px;
  padding-top: 20px;
  background-image: url("../assets/member_card_container_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.card_container {
  margin-top: -60px;
}

.carrier_container {
  background-image: url("../assets/member_card_cover.png");
  width: 100vw;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.link_button_container {
  width: 90vw;
  display: grid;
  place-items: center;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  padding: 10px 0;
  margin: 0 auto;
}

.not_login {
  // opacity: 0.4;
}
</style>
